(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/play_desktop.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/play_desktop.js'); 
(function(Backbone, _, svs) {
  'use strict';

  var isMarketplaceToggled = svs.maltipset.helpers.isMarketplaceToggled;
  svs.maltipset.views.Play = Backbone.Marionette.View.extend({
    regions: {
      coupon: '.maltipset-coupon',
      betslip: '#betslip-wrapper',
      statContainer: '.maltips-stat-container',
      drawSelector: '#drawChooser',
      game: '#game'
    },
    className: 'maltipset-play',
    template: function() {
      if (
        svs.maltipset.collections.draws &&
        svs.maltipset.collections.draws.any()
      ) {
        var coupon = svs.maltipset.collections.coupons.getCurrentCoupon(),
          showWideCoupon =
            !coupon.isMOrRSystem() && !coupon.get('xpertBaseRowMode');
        if (svs.core.detect.feature('ft-maltipset-direct-play')) {
          this.showWideCoupon = showWideCoupon;
        }
        return svs.maltipset.templates.play({ showWideCoupon: showWideCoupon });
      }
      return svs.maltipset.templates.play();
    },
    initProductBase: function() {
      var self = this,
        coupon = svs.maltipset.collections.coupons.getCurrentCoupon(),
        matchIndex = parseInt(this.options.matchNum.substring(0, 2), 10) - 1,
        selectedMatch =
          coupon
            .get('draw')
            .get('matchList')
            .at(matchIndex) ||
          coupon
            .get('draw')
            .get('matchList')
            .at(0),
        matchList = coupon.get('draw').get('matchList');
      if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
        matchList.matchClicked(selectedMatch, true);
        coupon.set('selectedMatch', selectedMatch, { silent: true });
      }
      this.listenTo(
        coupon,
        'change:selectedMatch',
        this.showStatsForMatch,
        this
      );
      this.listenTo(
        coupon,
        'change:system change:xpertBaseRowMode stopBaseRowEdit',
        this.changeCouponWidth,
        this
      );
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.bigStatView =
          this.bigStatView ||
          new svs.statistics.big.views.NavBigStatisticsView({
            showCloseButton: true,
            skippAnim: true,
            animateTo: 'right'
          });
      } else {
        this.bigStatView =
          this.bigStatView ||
          new svs.statistics.big.views.NavBigStatisticsView({
            showCloseButton: false
          });
      }

      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        if (svs.maltipset.views.coupon) {
          svs.maltipset.views.coupon.dispose();
        }
        svs.maltipset.views.coupon = new svs.maltipset.views.Coupon({
          model: coupon
        });
        var productBase = new svs.components.ProductBase({
          generalSettings: {
            branding: 'maltipset'
          },
          content: {
            gameColumn: {
              view: svs.maltipset.views.coupon,
              options: {
                grid: this.showWideCoupon
                  ? {
                    xs: 6,
                    sm: 6,
                    md: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 6
                        : 6,
                    lg: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 4
                        : 6,
                    xl: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 4
                        : 7
                  }
                  : { xs: 6, sm: 6, md: 4, lg: 4, xl: 4 },
                multiSwiper: {
                  nodeId: 'couponHolder',
                  toSubtract: [
                    '#top-content',
                    '.js-product-base-tabs-nav',
                    '#drawChooser'
                  ]
                }
              }
            },
            contentColumn: {
              view: this.bigStatView,
              options: {
                grid: this.showWideCoupon
                  ? {
                    xs: 6,
                    sm: 6,
                    md: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 6
                        : 6,
                    lg: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 8
                        : 6,
                    xl: svs.core.detect.feature('ft-betslip-maltipset')
                        ? 8
                        : 5
                  }
                  : { xs: 6, sm: 6, md: 8, lg: 8, xl: 8 }
              }
            }
          },
          tabs: svs.maltipset.data.config.startPageConfig
            ? svs.maltipset.data.config.startPageConfig.tabs
            : []
        });

        this.getRegion('game').show(productBase);
        this.productBaseGame = productBase.$el.find('#game-column');
        this.productBaseContent = productBase.$el.find('#content-column');

        this.clearSelectedMatch();
        this.bigStatView.on('bigNav:animate-out-complete', function() {
          self.clearSelectedMatch();
        });

        svs.maltipset.multiSwiper = productBase.getMultiSwiper();
        svs.maltipset.productBase = productBase;
        if (productBase) {
          productBase.on('tabChanged', function() {
            self.oldQuerystring = null;
            if (self.bigStatView.model.get('history').length > 0) {
              self.bigStatView.trigger('closeRegionStandard', {
                event: 'animate-out-complete'
              });
            }
          });
        }
      } else {
        this.getRegion('coupon').show(
          new svs.maltipset.views.Coupon({ model: coupon })
        );
        this.getRegion('statContainer').show(this.bigStatView);
        this.showStatsForMatch(coupon, selectedMatch);
      }

      if (
        isMarketplaceToggled() &&
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)
      ) {
        svs.core.module.load(
          '/cl/marketplace/react:account-selector',
          null,
          function() {
            if (
              svs.components.marketplace &&
              svs.components.marketplace.accountSelector
            ) {
              var drawNumber = svs.maltipset.collections.draws.models[
                svs.maltipset.collections.draws.currentDrawIndex
              ].get('drawNumber');
              var productId = svs.maltipset.collections.draws.models[
                svs.maltipset.collections.draws.currentDrawIndex
              ].get('productId');

              svs.components.marketplace.accountSelector.helpers.fetchGames(
                {
                  drawNumber: drawNumber,
                  productId: productId
                },
                function() {
                  svs.maltipset.controllers.maltipsetController.showBetslip(
                    coupon
                  );
                }
              );
            } else {
              svs.maltipset.controllers.maltipsetController.showBetslip(coupon);
            }
          }
        );
      } else {
        svs.maltipset.controllers.maltipsetController.showBetslip(coupon);
      }
      this.$el.toggleClass(
        'system-active',
        coupon.isMOrRSystem() || coupon.get('xpertBaseRowMode')
      );

      $('body').addClass('bg-maltipset-400 body-overflow-hidden');

      if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.addDrawSelector();
      }

      if (!svs.maltipset.multiSwiper) {
        this.setupMultiSwiper();
      }

      svs.maltipset.multiSwiper.updateSize();

      var swiper = $('.js-swiper-container').has('#coupon'),
        playContent = $('.maltipset-play-content'),
        targetOffset = playContent.offset().top - swiper.offset().top,
        checkPosition = _.debounce(function() {
          if (swiper.scrollTop() > targetOffset) {
            playContent.css({
              position: 'static'
            });
          } else {
            playContent.css({
              position: 'relative'
            });
          }
        }, 100);
      swiper.on('scroll', checkPosition);
    },

    onAttach: function() {
      if (
        svs.maltipset.collections.draws &&
        svs.maltipset.collections.draws.any()
      ) {
        this.initProductBase();
      } else {
        svs.maltipset.views.skeletonCoupon = new svs.maltipset.views.SkeletonCoupon();
        var productBase = new svs.components.ProductBase({
          generalSettings: {
            branding: 'maltipset'
          },
          content: {
            gameColumn: {
              view: svs.maltipset.views.skeletonCoupon,
              options: {
                grid: {
                  xs: 6,
                  sm: 6,
                  md: svs.core.detect.feature('ft-betslip-maltipset') ? 5 : 6,
                  lg: svs.core.detect.feature('ft-betslip-maltipset') ? 4 : 6,
                  xl: svs.core.detect.feature('ft-betslip-maltipset') ? 4 : 7
                }
              }
            },
            contentColumn: {
              options: {
                grid: {
                  xs: 6,
                  sm: 6,
                  md: svs.core.detect.feature('ft-betslip-maltipset') ? 7 : 6,
                  lg: svs.core.detect.feature('ft-betslip-maltipset') ? 8 : 6,
                  xl: svs.core.detect.feature('ft-betslip-maltipset') ? 8 : 5
                }
              }
            }
          },
          tabs: svs.maltipset.data.config.startPageConfig.tabs
        });

        this.getRegion('game').show(productBase);
      }
    },
    changeCouponWidth: function() {
      var coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
      if (coupon.isMOrRSystem() || coupon.get('xpertBaseRowMode')) {
        this.$el.addClass('system-active');
        if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
          this.getRegion('statContainer')
            .$el.parent()
            .addClass('col-md-8')
            .removeClass('col-xl-5');
          this.getRegion('coupon')
            .$el.parent()
            .addClass('col-md-4')
            .removeClass('col-xl-7');
        } else {
          if (svs.core.detect.feature('ft-betslip-maltipset')) {
            this.productBaseContent
              .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8')
              .addClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8');
            this.productBaseGame
              .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4')
              .addClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4');
          } else {
            this.productBaseContent
              .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-5')
              .addClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8');
            this.productBaseGame
              .removeClass('col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-7')
              .addClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4');
          }
        }
      } else {
        this.$el.removeClass('system-active');
        if (!svs.core.detect.feature('ft-maltipset-direct-play')) {
          this.getRegion('statContainer')
            .$el.parent()
            .removeClass('col-md-8')
            .addClass('col-xl-5');
          this.getRegion('coupon')
            .$el.parent()
            .removeClass('col-md-4')
            .addClass('col-xl-7');
        } else {
          if (svs.core.detect.feature('ft-betslip-maltipset')) {
            this.productBaseContent
              .removeClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8')
              .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8');
            this.productBaseGame
              .removeClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4')
              .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4');
          } else {
            this.productBaseContent
              .removeClass('col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8')
              .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-5');
            this.productBaseGame
              .removeClass('col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4')
              .addClass('col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-7');
          }
        }
      }
    },

    showStatsForMatch: function(coupon, match) {
      var currentCoupon =
          coupon || svs.maltipset.collections.coupons.getCurrentCoupon(),
        selectedMatch = match || currentCoupon.get('selectedMatch'),
        drawNum = currentCoupon.get('draw').get('drawNumber'),
        url =
          (svs.core.detect.feature('ft-maltipset-direct-play')
            ? '/'
            : 'spela/') +
          drawNum +
          '/' +
          selectedMatch.get('eventNumber'),
        eventDescription = selectedMatch
          .get('eventDescription')
          .replace(/ - /g, '-');
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        self.oldQuerystring = self.oldQuerystring || window.location.search;
        this.$el.find('.big-stat-container').removeClass('hide');
      }

      this.bigStatView.trigger('show-match', {
        matchId: selectedMatch.get('match').matchId,
        model: new svs.statistics.big.models.BigStatisticsModel({
          match: selectedMatch.get('match')
        })
      });
      url += '-' + svs.utils.url.encode(eventDescription);
      svs.core.data.title = svs.core.data.title || {};
      svs.core.data.title = _.extend(svs.core.data.title, {
        eventDescription: eventDescription
      });
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        svs.maltipset.router.navigate(url, { trigger: false, replace: true });
      } else {
        svs.maltipset.router.navigate(url + location.search, {
          trigger: false,
          replace: true
        });
      }
    },

    clearSelectedMatch: function() {
      var coupon = svs.maltipset.collections.coupons.getCurrentCoupon(),
        drawNum = coupon.get('draw').get('drawNumber');
      coupon.set('selectedMatch', null, { silent: true });
      svs.maltipset.router.navigate(
        '/' + drawNum + (self.oldQuerystring || window.location.search),
        { trigger: false, replace: true }
      );
      this.$el.find('.big-stat-container').addClass('hide');
      this.productBaseGame.find('.maltipset-match-row').removeClass('selected');
      self.oldQuerystring = null;
    },

    onDestroy: function() {
      svs.maltipset.controllers.maltipsetController.hideBetslip();
      $('body').removeClass('bg-maltipset-400 body-overflow-hidden');
      svs.maltipset.multiSwiper.destroyAllSwipers();
      svs.maltipset.multiSwiper = undefined;
    },

    setupMultiSwiper: function() {
      var multiSwiperOptions = {
        scrollerOptions: svs.core.detect.feature('ft-maltipset-direct-play')
          ? [
            {
              nodeId: 'couponHolder',
              toSubtract: [
                '#top-content',
                'js-product-base-tabs-nav',
                '#drawChooser'
              ]
            }
          ]
          : [
            {
              nodeId: 'couponHolder',
              toSubtract: ['#top-content', '#drawChooser']
            }
          ]
      };

      svs.maltipset.multiSwiper = svs.maltipset.multiSwiper
        ? svs.maltipset.multiSwiper
        : new svs.components.MultiSwiper(multiSwiperOptions);
      svs.maltipset.multiSwiper.init();
    },
    updateSwiper: function() {
      svs.maltipset.multiSwiper.updateSize();
    },
    addDrawSelector: function() {
      var drawselectorOptions = {
        callback: function(drawNum) {
          Backbone.history.navigate('spela/' + drawNum, {
            trigger: true,
            replace: true
          });
        },
        draws: svs.maltipset.collections.draws.getAllDraws(),
        currentDraw: svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .get('draw')
          .get('drawNumber'),
        branding: 'maltipset',
        swiperUpdateFunction: this.updateSwiper
      };
      this.getRegion('drawSelector').show(
        new svs.sport.drawselector.views.Drawselector(drawselectorOptions)
      );
    }
  });
})(Backbone, _, svs);

 })(window);